function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15 16.5h-.22a5.2 5.2 0 0 0-1.664.319 8.144 8.144 0 0 1-5.233 0 5.181 5.181 0 0 0-1.661-.319H6a6 6 0 0 0-6 6A1.5 1.5 0 0 0 1.5 24h18a1.5 1.5 0 0 0 1.5-1.5 6 6 0 0 0-6-6zM2.325 21.75a3.757 3.757 0 0 1 3.675-3h.222a3.031 3.031 0 0 1 .938.2 10.4 10.4 0 0 0 6.676 0 3.065 3.065 0 0 1 .943-.2H15a3.757 3.757 0 0 1 3.675 3zm.269-11.25a1.1 1.1 0 0 0 1.094-1.094V9a6.812 6.812 0 1 1 13.624 0v.594a3.222 3.222 0 0 1-3.218 3.218h-1.1a1.816 1.816 0 0 0-1.774-1.437H9.781a1.813 1.813 0 1 0 0 3.625h4.313A5.412 5.412 0 0 0 19.5 9.594V9a9 9 0 1 0-18 0v.406A1.1 1.1 0 0 0 2.594 10.5zM10.5 6a3 3 0 0 1 3 3 2.963 2.963 0 0 1-.411 1.487 3.33 3.33 0 0 1 .857.825h.147a1.691 1.691 0 0 0 1.4-.783A5.193 5.193 0 0 0 15.75 9a5.25 5.25 0 1 0-9.188 3.438A3.315 3.315 0 0 1 7.9 10.467 2.963 2.963 0 0 1 7.5 9a3 3 0 0 1 3-3z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportIcon);
export default __webpack_public_path__ + "static/media/support-icon.1ca59cd0.svg";
export { ForwardRef as ReactComponent };